var mockData = {
  id: '9bde91a4-80af-5e2b-90ce-00688642d28a',
  name: 'AOVetHospital',
  fromName: 'Jonathan ',
  successMessage: 'Thanks You!!',
  emailContentToCustomer: {
    id: 'ea63f4e5-ab8b-5061-bcfb-b6c2210d0afd',
    emailContentToCustomer: '<p>Thanks for contacting NVA. You will hear back soon from us.</p>'
  },
  emailContentToLocation: {
    id: '098938a0-552d-5d66-b002-4f2c155698a4',
    emailContentToLocation: '<p>There is new query from customer.</p>'
  },
  emailContentToFriend: {
    id: '5e6a8893-acd3-5011-af73-fc3c1b48b6ea',
    emailContentToFriend: '<p>There is new query from your friend.</p>'
  },
  locationEmailList: [{
    email: 'kkumari2@sapient.com'
  }, {
    email: 'ahussain@sapient.com'
  }]
};
export { mockData };